/// <reference path="../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />
namespace Nobox.Nobox {
    import fld = CampaignresultRow.Fields;

    @Serenity.Decorators.registerClass()
    export class CampaignresultGrid extends NoboxEntityGrid<CampaignresultRow, any> {
        protected getColumnsKey() { return CampaignresultColumns.columnsKey; }
        protected getDialogType() { return CampaignresultDialog; }
        protected getIdProperty() { return CampaignresultRow.idProperty; }
        protected getInsertPermission() { return CampaignresultRow.insertPermission; }
        protected getLocalTextPrefix() { return CampaignresultRow.localTextPrefix; }
        protected getService() { return CampaignresultService.baseUrl; }


        public deleteFun = () => { };
        public fqFun = () => { };
        public gmFun = () => { };
        public totalOnClick = () => { };

        constructor(container: JQuery) {
            super(container);
            var q = Q.parseQueryString();
            if (q["status"]) {
                var categoryCt = this.findQuickFilter(Serenity.Select2Editor,
                    CampaignresultRow.Fields.Status)
                categoryCt.value = q["status"];
            }
            if (q["sd"] && q["ed"]) {
                var categoryDt = this.findQuickFilter(CustomDateFilter,
                    CampaignresultRow.Fields.Sent);
                categoryDt.set_value(q["sd"]);
                categoryDt.end_set_value(q["ed"]);
            }
        }

        protected getButtons() {
            var $this = this;
            var buttons = super.getButtons();
            buttons.splice(0, 1);
            buttons.push({
                title: "Generate Messages",
                hint: "Generate Messages",
                separator: true,
                visible: false,
                cssClass: "btn-generate",
                icon: "fa-comment text-blue",
                onClick: () => {
                    this.gmFun();
                }
            });
            buttons.push({
                title: "Delete All Messages",
                icon: "fa-comment text-red",
                cssClass: "delete-all-messages",
                visible: false,
                separator: false,
                onClick: () => {
                    Q.confirm("Do you want to delete all broadcast messages in this Campaign? Deleted data cannot be recovered.", () => {
                        this.deleteFun();
                    });
                }
            });
            buttons.push({
                title: "Failed to Queue",
                icon: "fa-retweet  text-gray",
                cssClass: "failed-to-queue",
                visible: false,
                separator: true,
                onClick: () => {
                    this.fqFun();
                }
            });

            buttons.push({
                icon: "fa-bar-chart text-blue",
                separator: true,
                cssClass: "btn-total",
                hint: "Total Broadcast Message",
                visible:false,
                onClick: (e) => {
                    this.totalOnClick();
                }
            });
            return buttons;
        }
        protected getColumns(): Slick.Column[] {
            var columns = super.getColumns();
            var processBy = Q.getLookup("Nobox.AccountLookup").itemById;
            Q.first(columns, x => x.field == CampaignresultRow.Fields.ProcessBy).format =
                ctx => {
                    if (processBy[ctx.value] != undefined) {
                        return `<a href="javascript:;" class="account-link">${Q.htmlEncode(processBy[ctx.value].Name)}</a>`;
                    } else {
                        return "";
                    }
                };
            Q.first(columns, x => x.field == CampaignresultRow.Fields.Contact).format =
                ctx => {
                    return `<a href="javascript:;" class="contact-link">${Q.htmlEncode(ctx.value)}</a>`;
                };

            return columns;
        }
        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);

            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented()) {
                return;
            }

            // get reference to current item
            var item = this.itemAt(row);

            // get reference to clicked element
            var target = $(e.target);

            if (target.hasClass("contact-link")) {
                e.preventDefault();
                this.editItem(item.Id);
            } else if (target.hasClass("account-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by account");
                var accFilter = this.findQuickFilter(Serenity.ServiceLookupEditor,
                    CampaignresultRow.Fields.ProcessBy);
                accFilter.set_value(item.ProcessBy.toString());
                this.refresh()
            } else if (target.hasClass("tags-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by tags");
                var tagsFilter = this.findQuickFilter(Serenity.ServiceLookupEditor,
                    CampaignresultRow.Fields.Tags);
                tagsFilter.set_value(tagsFilter.get_value() + "," + target.text());
                this.refresh();
            } else if (target.hasClass("status-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by status");
                var channelFilter = this.findQuickFilter(Serenity.Select2Editor,
                    CampaignresultRow.Fields.Status);
                channelFilter.set_value(`${item.Status}`);
                this.refresh();
            }
        }
        protected getQuickFilters() {
            var flt = super.getQuickFilters();
            //this.refresh();
            var filter1 = Q.first(flt, x => x.field == CampaignresultRow.Fields.Tags);
            filter1.handler = h => {
                const request = (h.request as CampaignresultListRequest);
                const values = (h.widget as Serenity.ServiceLookupEditor).values;
                if (h.active) {
                    request.Tags = values.map(x => x);
                    h.handled = true;
                } else {
                    request.Tags = [];
                    h.handled = true;
                }
            };

            var filter2 = Q.first(flt, x => x.field == CampaignresultRow.Fields.Sent);
            filter2.handler = h => {
                const request = (h.request as CampaignListRequest);
                const start = (h.widget as CustomDateFilter).get_value();
                const end = (h.widget as CustomDateFilter).end_get_value();
                if (h.active) {
                    if (start != null && end != null) {
                        request.Criteria = [[["Sent"], ">=", start], "and", [["Sent"], "<=", end]]
                    } else if (start != null) {
                        request.Criteria = [["Sent"], ">=", start];
                    } else if (end != null) {
                        request.Criteria = [["Sent"], "<=", end];
                    }
                    h.handled = true;
                } else {
                    h.handled = true;
                }
            };

            return flt;
        }
        protected onViewSubmit(): boolean {
            if (!super.onViewSubmit()) { return false; }
            let request = this.view.params as Serenity.ListRequest;
            return true;
        }
    }
}